module.exports = __webpack_public_path__ + "WechatQRCode.png?2b69f9b6dbeeee34c61bd073e6bf0632";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WechatQRCode.png
// module id = 108
// module chunks = 0